import { Pipe, PipeTransform } from '@angular/core'

@Pipe({
  name: 'html2text',
  standalone: false,
})
export class Html2TextPipe implements PipeTransform {
  transform(text: string): string {
    return text ? String(text).replace(/<[^>]+>/gm, '') : ''
  }
}
